import { Button, Tooltip, mergeClasses } from "@fluentui/react-components";
import { Send16Regular, Pause16Regular } from "@/components/Icon";
import { useComposerButtonStyles } from "./composerButtonStyles";

/**
 * The composer's primary control, three states on the same pixel: muted while
 * there is nothing to send, flat ink once there is, and that same ink carrying
 * a Stop glyph while a reply streams.
 *
 * Stop needs a handler, not merely a streaming reply — the composer also locks
 * for an open agent question, which there is nothing to cancel, and a button
 * that cannot stop anything reads worse than a disabled send.
 */
export default function AiAskBarLandingSendButton({ vm, actions, sendDisabled }) {
  const styles = useComposerButtonStyles();
  const canStop = Boolean(vm.isGenerating) && typeof vm.onStopGenerating === "function";
  const canSend = vm.sendIsActive && !sendDisabled;
  const active = canStop || canSend;
  const label = canStop ? "Stop generating" : "Send";
  const Icon = canStop ? Pause16Regular : Send16Regular;

  return (
    <Tooltip content={label} relationship="label">
      <Button
        shape="circular"
        className={mergeClasses(styles.circle, active ? styles.sendActive : styles.sendIdle)}
        icon={<Icon className={styles.sendIcon} />}
        aria-label={label}
        disabled={!active}
        onClick={canStop ? vm.onStopGenerating : actions.handleSend}
      />
    </Tooltip>
  );
}
